import React from "react";
import { styled } from "@mui/material/styles";
import { TableCell } from "@mui/material";
import colors from "assets/theme-dark/base/colors";
import { HeadroomTableSegment } from "../../utils/headroomTableUtils";
import SortButton from "../SortButton";

interface SegmentHeaderProps {
  segment: HeadroomTableSegment;
  index: number;
  sortColumn: string;
  sortDirection: "asc" | "desc";
  handleSort: (column: string) => void;
}

const SegmentHeader: React.FC<SegmentHeaderProps> = ({ segment, index, sortColumn, sortDirection, handleSort }) => {
  const column = segment.method === "DATA" ? `segmentValue${index + 1}` : `range${index + 1}`;
  const label = `Segment ${segment.index + 1} - ${segment.segmentType} (${
    segment.method === "DATA" ? "Data" : "Manual"
  })`;

  return (
    <SubHeaderTableCell colSpan={2} align="center">
      <SortButton
        column={column}
        label={label}
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        handleSort={handleSort}
        maxLength={35}
      />
    </SubHeaderTableCell>
  );
};

const SubHeaderTableCell = styled(TableCell)(({ theme }) => ({
  border: `1px solid ${colors.grey[300]}`,
  padding: theme.spacing(1.5),
  fontSize: "0.75rem",
  backgroundColor: colors.grey[300],
  color: colors.text.primary,
}));

export default SegmentHeader;
